import { Box, Button } from "@mui/material"
import MapInsightsTable from "./MapInsightsTable"
import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import {
  configureFilter,
  processApproval,
  resetSelectedForApproval,
  setActiveTab,
  setInsightsData,
} from "./MapSlice"
import { useNavigate } from "react-router-dom"
import { SCREENS_DETAILS } from "../../../util/StaticData"
import FilterComp from "../dataset/FilterComp"
import { removeRedundancy } from "../dataset/SummaryTable"
import { useEffect } from "react"

const MappingInsights = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {
    activeTab,
    selectedForApproval,
    mappedData,
    absoluteMapped,
    approximateMapped,
    notMapped,
  } = useAppSelector((state) => state.map)
  const tabs = ["Absolute Mapped", "Approximate Mapped", "Not Mapped"]

  const allcountries = removeRedundancy(
    mappedData.map((data) => data.country_l),
  )
  const absoluteCountries = removeRedundancy(
    absoluteMapped.map((data) => data.country_l),
  )
  const approximateCountries = removeRedundancy(
    approximateMapped.map((data) => data.country_l),
  )
  const notMappedCountries = removeRedundancy(
    notMapped.map((data) => data.country_l),
  )

  const allCategory = removeRedundancy(
    mappedData.map((data) => data.category_l),
  )
  const absoluteCategory = removeRedundancy(
    absoluteMapped.map((data) => data.category_l),
  )
  const approximateCategory = removeRedundancy(
    approximateMapped.map((data) => data.category_l),
  )
  const notMappedCategory = removeRedundancy(
    notMapped.map((data) => data.category_l),
  )

  const allBrand = removeRedundancy(mappedData.map((data) => data.brand_l))
  const absoluteBrand = removeRedundancy(
    absoluteMapped.map((data) => data.brand_l),
  )
  const approximateBrand = removeRedundancy(
    approximateMapped.map((data) => data.brand_l),
  )
  const notMappedBrand = removeRedundancy(notMapped.map((data) => data.brand_l))

  useEffect(() => {
    if (absoluteMapped.length > 0) {
      activeTab === "All"
        ? dispatch(
            configureFilter({
              countries: allcountries,
              categories: allCategory,
              brands: allBrand,
            }),
          )
        : activeTab === "Absolute Mapped"
        ? dispatch(
            configureFilter({
              countries: absoluteCountries,
              categories: absoluteCategory,
              brands: absoluteBrand,
            }),
          )
        : activeTab === "Approximate Mapped"
        ? dispatch(
            configureFilter({
              countries: approximateCountries,
              categories: approximateCategory,
              brands: approximateBrand,
            }),
          )
        : dispatch(
            configureFilter({
              countries: notMappedCountries,
              categories: notMappedCategory,
              brands: notMappedBrand,
            }),
          )
    }
  }, [activeTab])

  const handleTabClick = (tabName: string) => {
    dispatch(setActiveTab(tabName))
  }

  const handleApproveClick = () => {
    dispatch(processApproval("approve"))
    dispatch(resetSelectedForApproval())
  }

  const handleRejectClick = () => {
    dispatch(processApproval("reject"))
    dispatch(resetSelectedForApproval())
  }

  const handleBackClick = () => {
    navigate(SCREENS_DETAILS.CREATE_SCENARIO)
  }

  useEffect(() => {
    dispatch(setInsightsData())
  }, [])

  return (
    <Box className="flex-1 grid grid-cols-1 gap-4 overflow-x-auto">
      <div className="flex flex-col gap-4 w-full grow">
        <div className="flex justify-between items-center">
          <p className="text-[18px] font-bold">AI Enabled Harmonization</p>
        </div>

        <div className="flex gap-1">
          <Button
            variant="contained"
            size="small"
            sx={{
              minWidth: "9rem",
              backgroundColor: activeTab === "All" ? "#CCCCCC" : "#E6E6E6",
              color: activeTab === "All" ? "#FFFFFF" : "#777777",
              "&:hover": {
                backgroundColor: "#A0A0A0",
                boxShadow: "none",
              },
              transition: "background-color 0.3s",
              fontWeight: activeTab === "All" ? 700 : 500,
              boxShadow: "0",
              textTransform: "none",
            }}
            onClick={() => handleTabClick("All")}
          >
            All
          </Button>
          <div className="flex gap-1 grow">
            {tabs.map((tab, ind) => (
              <Button
                onClick={() => handleTabClick(tab)}
                key={ind}
                variant="contained"
                size="small"
                sx={{
                  flexGrow: 1,
                  backgroundColor: activeTab === tab ? "#CCCCCC" : "#E6E6E6",
                  color: activeTab === tab ? "#FFFFFF" : "#7777777",
                  "&:hover": {
                    backgroundColor: "#A0A0A0",
                    boxShadow: "none",
                  },
                  transition: "background-color 0.3s",
                  fontWeight: activeTab === tab ? 700 : 500,
                  boxShadow: "none",
                  textTransform: "none",
                }}
              >
                {tab}
              </Button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4 bg-[white] p-3">
          <div className="flex justify-between">
            <Button
              onClick={handleBackClick}
              variant="contained"
              size="small"
              sx={{
                minWidth: "7rem",
                color: "white",
                fontweight: 600,
                boxShadow: "none",
                textTransform: "none",
              }}
            >
              Back
            </Button>
            <div className="flex gap-4">
              <Button
                onClick={handleApproveClick}
                variant="contained"
                size="small"
                sx={{
                  minWidth: "7rem",
                  backgroundColor: "status.green",
                  color: "white",
                  fontweight: 600,
                  boxShadow: "none",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "status.green",
                  },
                }}
                disabled={!selectedForApproval.length}
              >
                Approve
              </Button>
              <Button
                onClick={handleRejectClick}
                variant="outlined"
                size="small"
                sx={{
                  minWidth: "7rem",
                  border: "1px solid #7D7D7D",
                  color: "#7D7D7D",
                  fontweight: 600,
                  boxShadow: "none",
                  textTransform: "none",
                }}
                disabled={!selectedForApproval.length}
              >
                Reject
              </Button>
            </div>

            {/* <Typography>Approved</Typography> */}
          </div>

          <div className="grid grid-cols-1 gap-4 bg-[white]">
            <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
              <FilterComp />
              <MapInsightsTable activeTab={activeTab} />
            </Box>
          </div>
        </div>
      </div>
    </Box>
  )
}

export default MappingInsights
